Alpine.store("partnerDelivery", {
    products: [],
    blink: null,
    register_at: null,
    wid: null,
    contact_id: null,
    net: null,

    reset() {
        this.products = [];
        this.blink = null;
        this.register_at = null;
        this.contact_id = null;
        this.net = null;
        this.storage?.persist();
    },

    formData() {
        return {
            products: this.products,
            contact_id: this.contact_id,
            register_at: this.register_at,
            net: this.net,
        };
    },

    isEmpty() {
        return !!this.products?.length;
    },

    get storage() {
        if (!localStorage) {
            return null;
        }

        let store = this;
        return {
            persist() {
                const data = {
                    products: store.products,
                    contact_id: store.contact_id,
                    register_at: store.register_at,
                    net: store.net,
                    wid: store.wid,
                };
                localStorage.setItem(
                    "partner_delivery_data",
                    JSON.stringify(data),
                );
            },
            data() {
                return JSON.parse(
                    localStorage.getItem("partner_delivery_data") || "{}",
                );
            },
            restore(data) {
                if (!data) data = this.data();
                store.products = data.products || [];
                store.contact_id = data.contact_id;
                store.register_at = data.register_at;
                store.net = data.net;
            },
            reset() {
                localStorage.removeItem("partner_delivery_data");
            },
        };
    },

    prod: function (prod) {
        const store = this;
        return {
            get add() {
                let old = store.products.find((p) => p.id == prod.id);
                if (old) old.qte = (old.qte || 1) + 1;
                else {
                    store.products.unshift({
                        id: prod.id,
                        qte: 1,
                        // Prix par défaut = dernier prix d'achat (règle métier partenaire)
                        price: prod.last_purchase_price,
                        original: prod,
                    });
                }
                store.storage?.persist();
                this.blink();
            },

            get remove() {
                store.products.splice(store.products.indexOf(prod), 1);
                store.storage?.persist();
                return prod;
            },

            blink() {
                store.blink = prod.id;
                setTimeout(() => (store.blink = undefined), 500);
            },

            get ttc() {
                return prod.price * prod.qte;
            },
        };
    },

    prods: function () {
        let store = this;
        return {
            get ttc() {
                let a = 0;
                store.products.forEach((p) => (a += store.prod(p).ttc));
                return a;
            },
        };
    },

    get net() {
        return this.prods().ttc;
    },
});

Alpine.data("partnerDelivery", function (initial = {}) {
    return {
        init() {
            const store = this.$store.partnerDelivery;
            store.contact_id = initial.contact_id;
            store.register_at = initial.register_at;
            store.net = initial.net;
            store.wid = initial.wid;

            const old = store.storage?.data();
            if (old.wid != initial.wid) {
                store.storage?.reset();
            } else {
                store.storage?.restore();
            }
        },

        partner_delivery_reset() {
            this.$store.partnerDelivery.reset();
            this.$store.partnerDelivery.storage.reset();
        },

        partner_delivery_submit() {
            const store = this.$store.partnerDelivery;
            this.$wire.call("save_delivery", store.formData());
        },
    };
});
